/* 360° viewer: drag/touch/keyboard; IntersectionObserver prefetch; accessible + scroll-driven */
(function(){
  function safeIndex(len, i){ return ((i % len) + len) % len; }
  function clamp(v, min, max){ return Math.max(min, Math.min(max, v)); }
  function defer(cb, timeout){ if('requestIdleCallback' in window){ requestIdleCallback(cb, {timeout: timeout||500}); } else { setTimeout(cb, timeout||200); } }
  function parseAspectRatio(text){
    try{
      if(!text) return null;
      var s = String(text).replace(/\s+/g,'').toLowerCase();
      if(s === 'auto') return null;
      if(s.indexOf('/') !== -1){
        var parts = s.split('/');
        var w = parseFloat(parts[0]); var h = parseFloat(parts[1]);
        if(isNaN(w) || isNaN(h) || w <= 0 || h <= 0) return null;
        return w / h; // aspect-ratio: width/height
      }
      var r = parseFloat(s);
      if(isNaN(r) || r <= 0) return null;
      return r;
    }catch(_){ return null; }
  }
  function attrBool(el, name){
    var v = el.getAttribute(name);
    if (v === null) return false;
    return v === '' || v === 'true' || v === '1';
  }
  function whenReady(img, cb){
    if(!img){ cb(); return; }
    var ready = img.complete && img.naturalWidth > 0;
    var done = function(){ try{ img.decode ? img.decode().then(cb).catch(cb) : cb(); }catch(_){ cb(); } };
    if(ready){ done(); }
    else {
      var on = function(){ img.removeEventListener('load', on); done(); };
      img.addEventListener('load', on);
      // Ensure src is set
      var ds = img.getAttribute('data-src');
      if(ds && !img.getAttribute('src')){ img.setAttribute('src', ds); }
    }
  }
  function renderedHeight(img, container){
    try{
      // Si hay aspect-ratio definido en el contenedor, úsalo para altura estable
      var arAttr = container.getAttribute('data-aspect-ratio');
      var ar = parseAspectRatio(arAttr);
      var cw = container.clientWidth || 0;
      if(ar && cw > 0){
        var hAr = Math.round(cw / ar);
        return hAr > 0 ? hAr : container.offsetHeight || img.clientHeight || 0;
      }
      if(img.naturalWidth > 0 && img.naturalHeight > 0 && cw > 0){
        var h = Math.round(img.naturalHeight * (cw / img.naturalWidth));
        return h > 0 ? h : container.offsetHeight || img.clientHeight || 0;
      }
      return container.offsetHeight || img.clientHeight || 0;
    }catch(_){ return container.offsetHeight || 0; }
  }

  function readMaxHeightPx(el){
    try{
      var attr = el.getAttribute('data-max-height');
      var n = parseFloat(attr);
      if(isFinite(n) && n > 0) return n;
      var cs = window.getComputedStyle(el);
      var mh = cs.maxHeight;
      if(!mh || mh === 'none') return Infinity;
      var m = /([0-9.]+)px/.exec(mh);
      return m ? parseFloat(m[1]) : Infinity;
    }catch(_){ return Infinity; }
  }

  function Spin(el){
    this.el = el;
    this.frames = Array.prototype.slice.call(el.querySelectorAll('.pf-spin-frame'));
    this.index = 0;
    this.prevIndex = 0;
    this.dragging = false;
    this.lastX = 0;
    this.dragStartX = 0;
    this.dragStartIndex = 0;
    this.dragAccum = 0;
    this.observer = null;
    this.bound = false;
    this.rafId = null;
    var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    this.scrollDriven = attrBool(el, 'data-scroll-driven') && !reduceMotion;
    // Transición suave entre imágenes
    this.fadeMs = parseInt(el.getAttribute('data-transition-ms'), 10);
    if(isNaN(this.fadeMs)) this.fadeMs = 400; // recomendado
    if(reduceMotion) this.fadeMs = 0;
    // Easing configurable
    var ease = el.getAttribute('data-transition-easing');
    this.easing = (ease && ease.trim()) ? ease.trim() : 'ease-in-out'; // recomendado
    // Desplazamiento de la transición (px) para suavizar entrada/salida
    var sh = parseFloat(el.getAttribute('data-transition-shift'));
    if(isNaN(sh)) sh = 12;
    this.shiftPx = reduceMotion ? 0 : clamp(sh, 0, 30);
    this.transitioning = false;
    this.queuedIndex = null;
    this.lastUpdateTs = (typeof performance !== 'undefined' && performance.now) ? performance.now() : Date.now();
    this.minFadeInterval = 170; // más tiempo para completar fades con estabilidad
    // Duración específica para teclado y fade al soltar arrastre
    this.keyboardFadeMs = reduceMotion ? 0 : 200;
    var drms = parseFloat(el.getAttribute('data-drag-release-ms'));
    if(isNaN(drms)) drms = 175; // recomendado
    this.dragReleaseMs = reduceMotion ? 0 : clamp(drms, 0, 400);
    // Prefetch anticipado de varios frames por delante
    var pac = parseInt(el.getAttribute('data-prefetch-ahead'), 10);
    if(isNaN(pac)) pac = 3; // recomendado
    this.prefetchAheadCount = clamp(pac, 0, 6);
    // Aspect ratio opcional en contenedor (CSS nativo)
    var arStr = el.getAttribute('data-aspect-ratio');
    this.aspectRatio = parseAspectRatio(arStr);
    try{ if(this.aspectRatio){ this.el.style.aspectRatio = arStr; } }catch(_){/* noop */}
    // Modo de arrastre y si permite vueltas
    var dm = el.getAttribute('data-drag-mode');
    this.dragMode = (dm && dm.trim().toLowerCase()) || 'map'; // 'map' o 'step'
    this.dragWrap = attrBool(el, 'data-drag-wrap'); // por defecto false: no hay loops
    // Sensibilidad de arrastre basada en ancho visible (vueltas por ancho)
    var tpw = parseFloat(el.getAttribute('data-drag-turns-per-width'));
    if(isNaN(tpw)) tpw = 1;
    this.dragTurnsPerWidth = clamp(tpw, 0.25, 3); // rango razonable
    // Sensibilidad del scroll (por frame)
    var thrPct = parseFloat(el.getAttribute('data-scroll-threshold'));
    this.scrollThresholdPx = (!isNaN(thrPct) && thrPct > 0) ? ((window.innerHeight || document.documentElement.clientHeight || 800) * (thrPct / 100)) : 0;
    this.lastScrollY = window.scrollY || window.pageYOffset || 0;
    this.scrollAccum = 0;
    this.bind();
    this.observe();
    this.update(true);
    if (this.scrollDriven){ this.attachScroll(); }
  }

  Spin.prototype.bind = function(){
    var self = this;
    if (self.bound) return; self.bound = true;
    self.el.addEventListener('pointerdown', function(e){
      if(!attrBool(self.el, 'data-drag-enabled')) return;
      // Solo botón izquierdo
      if(e.button !== 0 && e.buttons !== 1) return;
      e.preventDefault();
      self.dragging = true;
      self.dragStartX = e.clientX;
      self.lastX = e.clientX;
      self.dragStartIndex = self.index;
      self.dragAccum = 0;
      try{ self.el.classList.add('is-dragging'); }catch(_){/* noop */}
      try{ self.el.setPointerCapture(e.pointerId); }catch(_){/* noop */}
    });
    self.el.addEventListener('pointermove', function(e){
      if(!attrBool(self.el, 'data-drag-enabled')) return;
      if(!self.dragging) return;
      e.preventDefault();
      // Si el dispositivo reporta estado de botones, asegúrate de que sigue presionado el izquierdo
      if(typeof e.buttons !== 'undefined' && (e.buttons & 1) === 0) return;
      if(self.dragMode === 'map'){
        // Mapeo directo de posición horizontal -> índice de frame (sin loops)
        var rect = self.el.getBoundingClientRect();
        var ratio = (e.clientX - rect.left) / (rect.width || 1);
        ratio = clamp(ratio, 0, 1);
        var target = Math.round(ratio * (self.frames.length - 1));
        if(target !== self.index){ self.index = target; self.update(true, { source: 'drag' }); }
        self.lastX = e.clientX;
      } else {
        // Modo por pasos similar al actual, con opción de evitar vueltas
        var dx = e.clientX - self.lastX;
        if(dx === 0) return;
        self.lastX = e.clientX;
        self.dragAccum += dx;
        var w = self.el.clientWidth || (document.documentElement.clientWidth || 1024);
        var frames = self.frames.length || 1;
        var pxPerFrame = w / (frames * self.dragTurnsPerWidth);
        // Evita jitter extremo
        if(pxPerFrame < 2) pxPerFrame = 2;
        var abs = Math.abs(self.dragAccum);
        var steps = Math.floor(abs / pxPerFrame);
        if(steps >= 1){
          var sign = self.dragAccum > 0 ? 1 : -1;
          var delta = steps * sign;
          self.dragAccum = sign * (abs - steps * pxPerFrame);
          var nextIdx = self.index + delta;
          if(self.dragWrap){
            self.index = safeIndex(self.frames.length, nextIdx);
          } else {
            var clamped = clamp(nextIdx, 0, self.frames.length - 1);
            // Si tocamos límites, resetea acumulación para no seguir intentando cambiar
            if(clamped === 0 || clamped === self.frames.length - 1){ self.dragAccum = 0; }
            self.index = clamped;
          }
          self.update(true, { source: 'drag' }); // sin fade durante arrastre
        }
      }
    });
    self.el.addEventListener('pointerup', function(){
      if(!attrBool(self.el, 'data-drag-enabled')) return;
      self.dragging = false;
      try{ self.el.classList.remove('is-dragging'); }catch(_){/* noop */}
      // Pequeño fade de suavizado al finalizar arrastre
      self.update(false, { source: 'drag_release', overrideMinInterval: true });
    });
    self.el.addEventListener('pointerleave', function(){
      if(!attrBool(self.el, 'data-drag-enabled')) return;
      if(!self.dragging) return;
      self.dragging = false;
      try{ self.el.classList.remove('is-dragging'); }catch(_){/* noop */}
      self.update(false, { source: 'drag_release', overrideMinInterval: true });
    });
    self.el.addEventListener('pointercancel', function(){
      if(!attrBool(self.el, 'data-drag-enabled')) return;
      if(!self.dragging) return;
      self.dragging = false;
      try{ self.el.classList.remove('is-dragging'); }catch(_){/* noop */}
      self.update(false, { source: 'drag_release', overrideMinInterval: true });
    });
    self.el.addEventListener('keydown', function(e){
      if(!attrBool(self.el, 'data-drag-enabled')) return;
      if(e.key === 'ArrowLeft'){ self.index = safeIndex(self.frames.length, self.index - 1); self.update(false, { source: 'keyboard' }); }
      else if(e.key === 'ArrowRight'){ self.index = safeIndex(self.frames.length, self.index + 1); self.update(false, { source: 'keyboard' }); }
      else if(e.key === 'Home'){ self.index = 0; self.update(false, { source: 'keyboard' }); }
      else if(e.key === 'End'){ self.index = self.frames.length-1; self.update(false, { source: 'keyboard' }); }
    });
    self.el.addEventListener('focus', function(){ self.ensureLoaded(self.index); self.prefetch(self.index+1); });
  };

  // Permite activar/desactivar dinámicamente el modo scroll-driven
  Spin.prototype.setScrollDriven = function(enabled){
    enabled = !!enabled;
    if(enabled === this.scrollDriven) return;
    this.scrollDriven = enabled;
    try{ this.el.setAttribute('data-scroll-driven', enabled ? 'true' : 'false'); }catch(_){/* noop */}
    if(enabled){
      this.attachScroll();
    } else {
      if(this._onScroll){
        window.removeEventListener('scroll', this._onScroll);
        window.removeEventListener('resize', this._onScroll);
        this._onScroll = null;
      }
    }
  };

  Spin.prototype.attachScroll = function(){
    var self = this;
    function onScroll(){
      if(self.dragging) return;
      if(self.rafId) return; // throttle with rAF
      self.rafId = requestAnimationFrame(function(){ self.rafId = null; self.handleScroll(); });
    }
    self._onScroll = onScroll;
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll, { passive: true });
    // Initial sync
    onScroll();
  };

  Spin.prototype.handleScroll = function(){
    var rect = this.el.getBoundingClientRect();
    var vh = window.innerHeight || document.documentElement.clientHeight || 800;
    // Only update when at least partially visible
    if (rect.bottom <= 0 || rect.top >= vh) return;
    var y = window.scrollY || window.pageYOffset || 0;
    if(this.scrollThresholdPx > 0){
      // Modo desplazamiento amplio: acumula scroll y avanza por umbral
      var dy = y - this.lastScrollY; this.lastScrollY = y;
      if(dy === 0) return;
      var sign = dy > 0 ? 1 : -1;
      this.scrollAccum += dy;
      var abs = Math.abs(this.scrollAccum);
      var steps = Math.floor(abs / this.scrollThresholdPx);
      if(steps >= 1 && this.frames.length >= 2){
        var delta = steps * sign;
        this.scrollAccum = sign * (abs - steps * this.scrollThresholdPx);
        this.index = safeIndex(this.frames.length, this.index + delta);
        this.update();
      }
    } else {
      // Fallback: mapeo directo por banda del viewport
      var center = rect.top + rect.height / 2;
      var bandStart = vh * 0.10; // banda más amplia por defecto
      var bandEnd   = vh * 0.90;
      var p = (bandEnd - center) / (bandEnd - bandStart);
      p = clamp(p, 0, 1);
      var target = Math.floor(p * (this.frames.length));
      target = clamp(target, 0, this.frames.length - 1);
      if (this.frames.length >= 2 && target !== this.index){
        this.index = safeIndex(this.frames.length, target);
        this.update();
      }
    }
  };

  Spin.prototype.ensureLoaded = function(i){
    var f = this.frames[safeIndex(this.frames.length, i)];
    if (!f) return;
    var ds = f.getAttribute('data-src');
    if(ds && !f.getAttribute('src')){ f.setAttribute('src', ds); }
    f.setAttribute('decoding','async');
    f.setAttribute('loading','lazy');
    // Boost priority when focused for better UX
    f.setAttribute('fetchpriority', (document.activeElement === this.el) ? 'high' : 'low');
    f.classList.add('lazypreload');
  };

  Spin.prototype.prefetch = function(i){
    var f = this.frames[safeIndex(this.frames.length, i)]; if(!f) return;
    var ds = f.getAttribute('data-src');
    if(ds && !f.getAttribute('src')){
      defer(function(){ f.setAttribute('src', ds); f.setAttribute('decoding','async'); f.setAttribute('loading','lazy'); f.setAttribute('fetchpriority','low'); });
    }
  };

  Spin.prototype.prefetchAhead = function(nextIdx, dir, count){
    var len = this.frames.length;
    if(len <= 0 || count <= 0) return;
    for(var j=1;j<=count;j++){
      var idx = safeIndex(len, nextIdx + j * dir);
      this.prefetch(idx);
      var img = this.frames[idx];
      if(img && img.decode && img.complete){ defer(function(){ try{ img.decode(); }catch(_){/* noop */} }); }
    }
  };

  Spin.prototype.observe = function(){
    var self = this;
    if('IntersectionObserver' in window){
      var done=false;
      self.observer = new IntersectionObserver(function(entries){
        entries.forEach(function(entry){
          if(entry.isIntersecting && !done){
            done = true;
            // Eagerly load current and next frame when entering viewport
            self.ensureLoaded(self.index);
            self.prefetch(self.index+1);
            try{ self.observer.disconnect(); }catch(_){/* noop */}
          }
        });
      }, {rootMargin: '200px 0px', threshold: 0.25});
      self.observer.observe(self.el);
    } else {
      // Fallback: load on DOM ready
      defer(function(){ self.ensureLoaded(self.index); self.prefetch(self.index+1); });
    }
  };

  Spin.prototype.update = function(immediate, opts){
    var targetIdx = this.index;
    var nextIdx = targetIdx;
    var prevIdx = this.prevIndex;
    var frames = this.frames;
    if(frames.length === 0) return;
    this.ensureLoaded(nextIdx);
    // Decide dirección de movimiento para prefetch y animación
    var len = frames.length;
    var fwd = (nextIdx - prevIdx + len) % len;
    var back = (prevIdx - nextIdx + len) % len;
    var dir = (fwd === 0 && back === 0) ? 1 : (fwd <= back ? 1 : -1);
    this.prefetch(nextIdx + dir);
    this.prefetchAhead(nextIdx, dir, this.prefetchAheadCount);

    // Suavizado de saltos grandes: encadena en pasos adyacentes
    var deltaSteps = Math.min(fwd, back);
    var srcChainable = !(opts && opts.source === 'drag');
    var shouldChain = !immediate && !this.dragging && !this.transitioning && srcChainable && deltaSteps > 1;
    if(shouldChain){
      nextIdx = safeIndex(len, prevIdx + dir);
      this.queuedIndex = targetIdx;
    }

    var nowTs = (typeof performance !== 'undefined' && performance.now) ? performance.now() : Date.now();
    var src = opts && opts.source ? opts.source : null;
    var desiredMs = this.fadeMs;
    if(src === 'keyboard') desiredMs = this.keyboardFadeMs;
    else if(src === 'drag_release') desiredMs = this.dragReleaseMs;
    // Fade más predecible: cuando no es inmediato, no estamos arrastrando y hay cambio de frame
    var canFade = !immediate && desiredMs > 0 && prevIdx !== nextIdx && !this.dragging && !this.transitioning;

    if(!canFade){
      for(var i=0;i<frames.length;i++){
        var f = frames[i];
        var active = (i===nextIdx);
        f.style.display = active ? 'block' : 'none';
        f.style.opacity = active ? '1' : '0';
        f.setAttribute('aria-hidden', active ? 'false' : 'true');
      }
      this.prevIndex = nextIdx;
      this.lastUpdateTs = nowTs;
      return;
    }

    // Transición de desvanecimiento (crossfade no intrusivo)
    var prev = frames[prevIdx];
    var next = frames[nextIdx];
    if(!prev || !next) return;
    var self = this;
    self.transitioning = true;
    // Mostrar siguiente frame y preparar overlay sin colapsar el contenedor
    next.style.display = 'block';
    next.style.opacity = '0';
    var easing = this.easing || 'ease-out';
    var shift = this.shiftPx || 0;
    var inStart = dir >= 0 ? shift : -shift;
    var outEnd = dir >= 0 ? -shift : shift;
    // Mantener el contenedor con altura estable aportada por el "next" en flujo normal.
    // El "prev" se pone en absoluto para superponer y hacer el crossfade.
    var cs = window.getComputedStyle(this.el);
    if(cs.position === 'static') this.el.style.position = 'relative';
    prev.style.position = 'absolute';
    prev.style.left = '0';
    prev.style.top = '0';
    prev.style.right = '0';
    prev.style.bottom = '0';
    prev.style.zIndex = '1';
    next.style.zIndex = '2';
    // Transiciones
    next.style.transition = 'opacity '+desiredMs+'ms '+easing+', transform '+desiredMs+'ms '+easing;
    prev.style.transition = 'opacity '+desiredMs+'ms '+easing+', transform '+desiredMs+'ms '+easing;
    prev.style.opacity = '1';
    // Hints para evitar parpadeo
    next.style.backfaceVisibility = 'hidden';
    next.style.willChange = 'opacity, transform';
    prev.style.backfaceVisibility = 'hidden';
    prev.style.willChange = 'opacity, transform';
    prev.setAttribute('aria-hidden','true');
    next.setAttribute('aria-hidden','false');
    whenReady(next, function(){
      requestAnimationFrame(function(){
        next.style.opacity = '1';
        prev.style.opacity = '0';
        if(shift){
          next.style.transform = 'translate3d(0,0,0)';
          prev.style.transform = 'translate3d('+outEnd+'px,0,0)';
        }
      });
    });
    var finished = false;
    var finish = function(){
      if(finished) return; finished = true;
      // Reset estilos temporales
      next.style.transition = '';
      next.style.backfaceVisibility = '';
      next.style.willChange = '';
      prev.style.transition = '';
      prev.style.backfaceVisibility = '';
      prev.style.willChange = '';
      next.style.transform = '';
      prev.style.transform = '';
      prev.style.position = '';
      prev.style.left = '';
      prev.style.top = '';
      prev.style.right = '';
      prev.style.bottom = '';
      prev.style.zIndex = '';
      next.style.zIndex = '';
      // Ocultar anteriores, mantener activo
      for(var i=0;i<frames.length;i++){
        var f = frames[i];
        var active = (i===nextIdx);
        f.style.display = active ? 'block' : 'none';
        f.style.opacity = active ? '1' : '0';
        f.setAttribute('aria-hidden', active ? 'false' : 'true');
      }
      self.prevIndex = nextIdx;
      self.transitioning = false;
      self.lastUpdateTs = (typeof performance !== 'undefined' && performance.now) ? performance.now() : Date.now();
      var qi = self.queuedIndex; self.queuedIndex = null;
      next.removeEventListener('transitionend', finish);
      if(qi !== null && qi !== nextIdx){ self.index = qi; self.update(false, { source: src, overrideMinInterval: true }); }
    };
    // Asegurar finalización del fade incluso si transitionend no se dispara
    next.addEventListener('transitionend', function(e){ if(e.propertyName === 'opacity'){ finish(); } }, { once: true });
    setTimeout(finish, desiredMs + 50);
  };

  function init(){
    var wraps = document.querySelectorAll('.pf-spin-360');
    for(var i=0;i<wraps.length;i++){
      var w = wraps[i];
      if(w.__spin) continue;
      var frames = w.querySelectorAll('.pf-spin-frame');
      if(frames.length >= 2){ w.__spin = new Spin(w); }
    }
  }
  if(document.readyState !== 'loading') init(); else document.addEventListener('DOMContentLoaded', init);
})();